module.exports = __webpack_public_path__ + "media/images/pic/anime/dumplings-aa31b0d04641d2c18578faedd5d18a73.svg";